var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddSupervisor = function SvgAddSupervisor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 91.46 91.46",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke:#7b8fb5;}.cls-1,.cls-2,.cls-4,.cls-5{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-5{stroke-width:4.09px;}.cls-1,.cls-3,.cls-4,.cls-6{fill:#fff;}.cls-2,.cls-7,.cls-5{fill:none;}.cls-3{stroke-miterlimit:10;}.cls-3,.cls-4{stroke-width:4.01px;}.cls-7,.cls-6,.cls-8,.cls-9{stroke-width:0px;}.cls-10{clip-path:url(#clippath-1);}.cls-5{stroke-linecap:round;}.cls-11{clip-path:url(#clippath);}.cls-8{fill:#929eb6;}.cls-9{fill:#ffd25c;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: -146.32,
    cy: 98.99,
    r: 61.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -239.04,
    y: 5.94,
    width: 210.44,
    height: 210.44
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "supervisors"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m23.46,135.5l1.1-4.06-42.43-11.52L5.72,45.44c6.31-9.34,15.73-23.29,16.32-24.07l-3.37-2.53c-.85,1.13-15,22.11-16.62,24.5l-.17.25-9.12,28.78-40-13.31L-26.58-11l-4.04-1.19-20.66,70.12-18.39-4.34L-52.53-6.82l-4.05-1.15-17.23,60.73-45.7-7.01-10.32-57.72-4.14.74,10.53,58.94-.78,10.11-62.27-16.56,12.75-52.37-4.09-1-12.73,52.28-14.98-3.98c1.42-18.03,3.49-43.83,3.75-45.41-.02.12-.05.2-.06.24l-3.99-1.33c-.1.3-.36,1.08-4,47.6l-3.06,7.64-12.68-4.55L-292.67-7.7l-2.45,3.42,67.34,48.26.24.17,13.09,4.69-2.43,6.07-35.07-9.26-42.52-26.63-2.23,3.57,43.06,26.97,37.47,9.9,16.66,4.6-14.17,36.71-25.48-6.85-49.95-32.09-2.27,3.54,49.04,31.51-3.18,17.36,25.71,6.86-10.65,36-40.86,73.85,3.68,2.04,39.12-70.71,11.47,20.91,69.8,23.38c-2.59,14.26-4.42,24.33-4.55,24.94l2.06.45,2.06.45c.12-.53,1.96-10.66,4.47-24.49l43.48,14.57-3.4,11.54,4.04,1.19,3.36-11.39,30.22,10.13,1.34-3.99-30.37-10.18,5.1-17.3,19.32,6.31,25.8,20.32,2.6-3.31-26.39-20.78-20.15-6.58,16.31-55.35,90.39,24.11,1.09-4.07-90.29-24.08,7.95-26.99,86.29,23.43Zm-31.95-59.11l-13.44,42.42-39.71-10.78,13.23-44.92,39.91,13.28Zm-43.96-14.43l-13.25,44.97-17.72-4.81,12.62-44.48,18.35,4.33Zm-35.03,39.05l-35.08-9.53,3.19-41.46,44.42,6.81-12.53,44.17Zm-46.9,82.36l-4.17-1.23c4.16-22.97,8.46-46.72,9.81-54.2l31.26,8.34-15.35,54.13-21.54-7.04Zm6.37-59.58l4.17-23.95.72-4.15,34.49,9.36-7.71,27.18-31.67-8.45Zm2.1-43.79l-68-18.77,6.16-15.95,63.22,16.81-1.38,17.92Zm-86.88-23.98l6.29-15.73,14.65,3.89-6.14,15.92-14.8-4.08Zm17.35,9.16l69.2,19.1-.66,8.52-5.2,29.9-77.5-20.83,14.16-36.69Zm25.64,51.74l-3.26,12.28-41.51-11.07,3.63-12.27,41.14,11.06Zm-70.89-5.75l2.32-12.68,23.37,6.28-3.63,12.28-22.06-5.88Zm70.62,23.19l4.33-16.34,32.9,8.84c-2.74,15.16-6.41,35.43-9.79,54.1l-83.28-24.47,10.15-34.31,45.69,12.18Zm-44.1,45.36l-10.06-18.35,80.85,23.76c-1.1,6.06-2.16,11.9-3.13,17.26l-67.66-22.67Zm115.6,38.73l-43.92-14.71c.99-5.47,2.06-11.38,3.16-17.42l3.65,1.07,42.19,13.79-5.09,17.27Zm6.28-21.31l-16.56-5.41,15.42-54.35,17.39,4.64-16.24,55.13Zm17.43-59.17l-17.43-4.65,7.7-27.16,17.68,4.8-7.96,27.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -88.65,
    y: -93.07,
    width: 4.21,
    height: 228.32,
    transform: "translate(-85.38 -67.98) rotate(-75.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -80.37,
    y: -99.81,
    width: 4.21,
    height: 228.32,
    transform: "translate(-72.64 -65.02) rotate(-75.55)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a\\xF1ade"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.11,
    cy: 40.66,
    r: 37.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m14.62,67.02c0-14.63,11.86-24.78,26.49-24.78s26.49,10.15,26.49,24.78"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_157",
    className: "cls-3",
    cx: 41.08,
    cy: 65.1,
    rx: 5.69,
    ry: 12.75,
    transform: "translate(-.71 .46) rotate(-.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5760",
    className: "cls-4",
    d: "m45.66,46.63c0,2.53-.96,6.26-4.57,6.26s-4.57-4.28-4.57-6.81"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.11,
    cy: 32.82,
    r: 13.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 69.79,
    cy: 71.09,
    r: 19.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 69.79,
    y1: 62.67,
    x2: 69.79,
    y2: 79.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 78.3,
    y1: 71.09,
    x2: 61.29,
    y2: 71.09
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddSupervisor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "add_supervisor.8d179273e0ac09a97532a07967e4a481.svg";